module.exports = __webpack_public_path__ + "static/media/BlueInformationToolTip.svg";